// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
import { OccViewer } from "../viewer/viewer.js";
/**
 * Update [[InteractiveContext]] in OccViewer.
 * @internal
*/
OccViewer.onInit((theModule) => {
    let anInteractiveContext = theModule.interactiveContext;
    anInteractiveContext.splitObjectId = function (theNames) {
        if (theNames.length == 0) {
            return [];
        }
        else {
            return theNames.split("\n");
        }
    };
    Object.defineProperty(anInteractiveContext, "displayedObjectList", {
        get: function () { return this.splitObjectId(this.displayedObjects); },
    });
    Object.defineProperty(anInteractiveContext, "erasedObjectList", {
        get: function () { return this.splitObjectId(this.erasedObjects); },
    });
    Object.defineProperty(anInteractiveContext, "insideObjectList", {
        get: function () { return this.splitObjectId(this.insideObjects); },
    });
    anInteractiveContext.joinObjectIdList = function (theNames) { return theNames.join("\n"); };
    let loadObjectListAsync = function (theNames, theToDisplay, theToUpdate) {
        const self = theModule;
        return new Promise((resolve, reject) => {
            const callable = {
                obj: undefined,
                resolve: function () {
                    resolve(true);
                    this.obj.delete();
                },
                reject: function (theErr) {
                    //@ts-ignore
                    self.printErr(theErr);
                    resolve(false);
                    this.obj.delete();
                },
            };
            const callableObject = theModule.IPromise.implement(callable);
            callable.obj = callableObject;
            //@ts-ignore
            const ret = anInteractiveContext._cppLoadObjectList(theNames, callableObject, theToDisplay, theToUpdate);
            if (!ret) {
                //@ts-ignore
                callableObject.delete();
                resolve(false);
            }
        });
    };
    loadObjectListAsync = loadObjectListAsync.bind(anInteractiveContext);
    anInteractiveContext.displayObjectListAsync = function (theNames, theToUpdate) { return loadObjectListAsync(theNames, true, theToUpdate); };
    anInteractiveContext.loadObjectListAsync = function (theNames) { return loadObjectListAsync(theNames, false, false); };
    anInteractiveContext.displayObjectList = function (theNames, theToUpdate) { return this._cppLoadObjectList(theNames, null, true, theToUpdate); };
    anInteractiveContext.removeAllObjects = function (theToUpdate) { return this._cppRemoveObjectList("*", theToUpdate, false); };
    anInteractiveContext.removeObjectList = function (theNames, theToUpdate) { return this._cppRemoveObjectList(theNames, theToUpdate, true); };
    anInteractiveContext.eraseAll = function (theToUpdate) { return this.eraseObjectList("*", theToUpdate); };
    anInteractiveContext.setCustomColorTriangles = function (theObjId, groupColors, theIsReplace) {
        //@ts-ignore
        const groupColorVector = new theModule["GroupColorVector"]();
        for (let i = 0; i < groupColors.length; i++) {
            //@ts-ignore
            const triangles = new theModule["IntVector"]();
            for (let j = 0; j < groupColors[i].triangles.length; j++) {
                triangles.push_back(groupColors[i].triangles[j]);
            }
            const group = {
                triangles: triangles,
                color: groupColors[i].color,
            };
            groupColorVector.push_back(group);
            triangles.delete();
        }
        //@ts-ignore
        this._cppCustomColorTriangles(theObjId, groupColorVector, theIsReplace);
        groupColorVector.delete();
    };
});
